import LaunchIcon from "@material-ui/icons/Launch"
import Button from "@material-ui/core/Button"
import ResumePdf from "../assets/dan-boudet-resume-081626.pdf"
// import { withStyles, makeStyles, ThemeProvider } from "@material-ui/core/styles"
// import { lightGreen } from "@material-ui/core/colors"

export default function Resume() {
  // const ColorButton = withStyles((theme) => ({
  //   root: {
  //     color: theme.palette.getContrastText(palette.primary),
  //     backgroundColor: { primary },
  //     "&:hover": {
  //       backgroundColor: lightGreen["700"],
  //     },
  //   },
  // }))(Button)

  // const useStyles = makeStyles((theme) => ({
  //   margin: {
  //     margin: theme.spacing(1),
  //   },
  // }))

  // const classes = useStyles()

  return (
    <a
      href={ResumePdf}
      target="_blank"
      rel="noreferrer"
      style={{textDecoration:"none"}}
    >
      {/* <ThemeProvider theme={theme}> */}
        <Button
          variant="contained"
          color="primary"
          size="large"
          p="16px"
          endIcon={<LaunchIcon />}
        >
          RESUME
        </Button>
      {/* </ThemeProvider> */}
    </a>
  )
}
